// extracted by mini-css-extract-plugin
export default {"red":"Loyalty_red__r1rz6","greenText":"Loyalty_greenText__L5JJU"};